import React from 'react'
import { useTranslation } from 'react-i18next'
import TableEmptyState from './TableEmptyState'

/** @deprecated Prefer TableEmptyState — kept as a thin wrapper for analysis charts. */
export default function AnalysisEmptyState({
  title,
  hint,
}: {
  title?: string
  hint?: string
}) {
  const { t } = useTranslation()
  return (
    <TableEmptyState
      compact
      title={
        title ??
        t('charts.noData', { defaultValue: 'Nothing to show yet' })
      }
      hint={
        hint ??
        t('charts.noDataHint', {
          defaultValue:
            'This indicator will appear once related records exist.',
        })
      }
    />
  )
}
